document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', function(event) {

  let titles = document.querySelectorAll('.cpb-category-title');
  let categories = document.querySelectorAll('.cpb-category');
  categories[1].classList.add('collapsible-open');
  titles.forEach(function(title) {
      title.addEventListener('click', function() {
          categories.forEach(function(category) {
              category.classList.remove('collapsible-open');
          });
        var element = document.querySelector(".Füßediv");
        if (element) { element.classList.remove('collapsible-open')};
        var element = document.querySelector(".Oberdiv");
        if (element) { element.classList.remove('collapsible-open')};
        let parentCategory = this.closest('.cpb-category');
          parentCategory.classList.toggle('collapsible-open');
      });
  });

const attachClickEvent = (clickElement) => {
    let titles = document.querySelectorAll('.cpb-category-title');
  let categories = document.querySelectorAll('.cpb-category');
    clickElement.addEventListener("click", function() {
        titles.forEach(function(title) {
      title.addEventListener('click', function() {
          categories.forEach(function(category) {
              category.classList.remove('collapsible-open');
          });
        var element = document.querySelector(".Füßediv");
        if (element) { element.classList.remove('collapsible-open')};
        var element = document.querySelector(".Oberdiv");
        if (element) { element.classList.remove('collapsible-open')};
        let parentCategory = this.closest('.cpb-category');
          parentCategory.classList.toggle('collapsible-open');
      });
  });
        let parentCategory = this.closest('.cpb-category');
        parentCategory.classList.toggle('collapsible-open');
    });
}

const observer = new MutationObserver(mutations => {
  mutations.forEach(mutation => {
    mutation.addedNodes.forEach(node => {
      if (node.nodeType === 1 && node.matches(".Füßediv")) {
      const parent = document.querySelector(".Füßediv");
      const child = parent.querySelector(".cpb-category-title");
        attachClickEvent(child);
      };
      if (node.nodeType === 1 && node.matches(".Oberdiv")) {
      const parent = document.querySelector(".Oberdiv");
      const child = parent.querySelector(".cpb-category-title");
        attachClickEvent(child);
      };
    });
  });
});
observer.observe(document.body, { childList: true, subtree: true });
  
const targetEl = document.querySelector('.cpb-selection-summary-total-price');
const html = '<p class="product-meta__taxes-included text--small">Inkl. MwSt. zzgl.<a href="/policies/shipping-policy" class="link link--accented"> Versand</a></p>';
targetEl.insertAdjacentHTML('afterend', html); 

let parentElements = document.querySelectorAll('.sc-epnACN.hsXqzQ.cpb-option__wrapper');

for (let i = 0; i < parentElements.length; i++) {
  let parentElement = parentElements[i];
  let targetElement1 = parentElement.querySelectorAll('.option.option-type-img')[11];
  targetElement1.insertAdjacentHTML('beforebegin', '<hr><div class="titel">Echtholzfunier:</div>');
  let targetElement2 = parentElement.querySelector('.option.option-type-img');
  targetElement2.insertAdjacentHTML('beforebegin', '<div class="titel">Dekore:</div>');
}

// Find the ".cpb-actions-btn cpb-add-to-cart-button" element
const addToCartButton = document.querySelector('.cpb-actions-btn.cpb-add-to-cart-button');
const musterButton = document.createElement('a');
musterButton.href = '/pages/muster';
musterButton.target = '_blank'; 
musterButton.className = 'muster-button cpb-actions-btn cpb-add-to-cart-button';
musterButton.textContent = 'Muster bestellen';

addToCartButton.parentNode.insertBefore(musterButton, addToCartButton.nextSibling);

});


//AB Hier
/*
document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', function(event) {
    function addClassToDiv() {
        let div = document.querySelector('div[data-option-id="r3mmxsy5dJWnZcHpMcH80mub"]');
        div.classList.add("Test123");
        console.log("ab hier")

        div.addEventListener("mouseover", function() {
            let tooltip = document.createElement("div");
            let img = document.createElement("img");
            img.src = "https://storage.googleapis.com/custom-product-builder/68939776300/denidro-bad-8105416884524-kEQF8UakZQOo1qmMb8NP9mX1.png";
            img.alt = "Fuß L Stahl";
            tooltip.appendChild(img);
            tooltip.classList.add("tooltip123");
            div.appendChild(tooltip);
        });

        div.addEventListener("mouseout", function() {
            let tooltip = document.querySelector(".tooltip123");
            div.removeChild(tooltip);
        });
    }
    setTimeout(addClassToDiv, 1000);
});




*/
/*
document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', function() {
let div = document.querySelector('div[data-option-id="r3mmxsy5dJWnZcHpMcH80mub"]');
  div.classList.add("new-class");
})




*/










/*
//Dennis Programmierung fängt hier an
document.body.addEventListener("DOMContentLoaded", function () {
const Massdiv = document.querySelector(".Massdiv .css-1uccc91-singleValue");
const value = Massdiv.textContent;
console.log(value);
  console.log("was hier los"+value)
})*/




/*

document.body.addEventListener("CPB_ON_PRODUCT_MOUNTED", function() {
let BreiteLi = document.querySelector("ul.sc-dqBHgY li:nth-child(1)");
let ÜBreiteDiv = BreiteLi.querySelector("div.sc-dfVpRl");
ÜBreiteDiv.classList.add("Breite");
})*/
/*
 document.body.addEventListener("CPB_ON_PRODUCT_MOUNTED", function () {
        let BreiteLi = document.querySelector("ul.sc-dqBHgY li:nth-child(1)");
        let TiefeLi = document.querySelector("ul.sc-dqBHgY li:nth-child(2)");
        let HöheLi = document.querySelector("ul.sc-dqBHgY li:nth-child(3)");
        let KorpusLi = document.querySelector("ul.sc-dqBHgY li:nth-child(4)");
        let FrontLi = document.querySelector("ul.sc-dqBHgY li:nth-child(5)");
        let SchubkastenLi = document.querySelector("ul.sc-dqBHgY li:nth-child(6)");
        let OberflächeLi = document.querySelector("ul.sc-dqBHgY li:nth-child(7)");
        let MontageLi = document.querySelector("ul.sc-dqBHgY li:nth-child(8)");
        let MöbeltypLi = document.querySelector("ul.sc-dqBHgY li:nth-child(9)");
    
    
        let ÜBreiteDiv = BreiteLi.querySelector("div.sc-dfVpRl");
        let IBreiteDiv = BreiteLi.querySelector("div.sc-iyvyFf");
    
        let ÜTiefeDiv = TiefeLi.querySelector("div.sc-dfVpRl");
        let ITiefeDiv = TiefeLi.querySelector("div.sc-iyvyFf");
    
        let ÜHöheDiv = HöheLi.querySelector("div.sc-dfVpRl");
        let IHöheDiv = HöheLi.querySelector("div.sc-iyvyFf");
    
        let ÜKorpusDiv = KorpusLi.querySelector("div.sc-dfVpRl");
        let IKorpusDiv = KorpusLi.querySelector("div.sc-iyvyFf");
    
        let ÜFrontDiv = FrontLi.querySelector("div.sc-dfVpRl");
        let IFrontDiv = FrontLi.querySelector("div.sc-iyvyFf");
    
        let ÜSchubkastenDiv = SchubkastenLi.querySelector("div.sc-dfVpRl");
        let ISchubkastenDiv = SchubkastenLi.querySelector("div.sc-iyvyFf");
    
        let ÜOberflächeDiv = OberflächeLi.querySelector("div.sc-dfVpRl");
        let IOberflächeDiv = OberflächeLi.querySelector("div.sc-iyvyFf");
    
        let ÜMontageDiv = MontageLi.querySelector("div.sc-dfVpRl");
        let IMontageDiv = MontageLi.querySelector("div.sc-iyvyFf");
    
        let ÜMöbeltypDiv = MöbeltypLi.querySelector("div.sc-dfVpRl");
        let IMöbeltypDiv = MöbeltypLi.querySelector("div.sc-iyvyFf");
    
    
    
        ÜBreiteDiv.classList.add("Breite");
        IBreiteDiv.classList.add("Breite");
    
        ÜTiefeDiv.classList.add("Breite");
        ITiefeDiv.classList.add("Breite");
    
        ÜHöheDiv.classList.add("Breite");
        IHöheDiv.classList.add("Breite");
    
        ÜKorpusDiv.classList.add("Breite");
        IKorpusDiv.classList.add("Breite");
    
        ÜFrontDiv.classList.add("Breite");
        IFrontDiv.classList.add("Breite");
    
        ÜSchubkastenDiv.classList.add("Breite");
        ISchubkastenDiv.classList.add("Breite");
    
        ÜOberflächeDiv.classList.add("Breite");
        IOberflächeDiv.classList.add("Breite");
    
        ÜMontageDiv.classList.add("Breite");
        IMontageDiv.classList.add("Breite");
    
        ÜMöbeltypDiv.classList.add("Breite");
        IMöbeltypDiv.classList.add("Breite");
    
    
        
    }); */
//Dennis Programmierung endet hier 